import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import GenericTable from '../../components/GenericTable/GenericTable';
import SearchBar from '../../components/SearchBar/SearchBar'; 
import {  FaTimesCircle, FaPen } from 'react-icons/fa';
import Pagination from '../../components/Pagination/Pagination';
import DomainForm from '../../components/DomainForm/DomainForm';
import Cookies from 'js-cookie';
import DomainCard from '../../components/DomainCard/DomainCard';
import MultiValueInput from '../../components/MultiValue/MultiValue'


function DomainsPage() {
    const [domains, setDomains] = useState({});
    const [pools, setPools] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState('');
    const domainsPerPage = 10; // Adjust as needed
    const navigate = useNavigate();


    useEffect(() => {
        const fetchDomains = async () => {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/domain`, {
                method: "GET",
                credentials: "include"
            });
            if (response.status === 401) {
                Cookies.remove('session-id');
                navigate('/login');
            }
            const body = await response.json();
            console.log(body.data);
            setDomains(body.data);
        };
        fetchDomains();

        const fetchPools = async () => {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/pool`, {
                method: "GET",
                credentials: "include"
            });
            if (response.status === 401) {
                Cookies.remove('session-id');
                navigate('/login');
            }
            const body = await response.json();
            setPools(body.data.map(pool => pool.title));
        };
        fetchPools();

    }, [navigate]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleAddDomains = async (formData) => {
        const hostnames = formData
        if (hostnames.length === 0) {
            return;
        }

        console.log(hostnames);

        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/domain`, {
            method: 'POST',
            credentials: "include",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(hostnames)
        });
        if (response.status === 401) {
            Cookies.remove('session-id');
            navigate('/login');
        }
        if (response.ok) {
            const body = await response.json();
            console.log('body.data', body.data);

            setDomains(prevDomains => {
                const updatedDomains = { ...prevDomains }; // Create a copy of the existing domains
                body.data.forEach(domain => {
                    updatedDomains[domain.hostname] = {pools: []};
                });
                return updatedDomains; // Return the updated domains object
            });
        }
    };

    const handleDeleteDomain = async (hostname) => {
        console.log(`delete ${hostname}`);

        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/domain?hostname=${hostname}`, {
            method: "DELETE",
            credentials: "include"
        })
        if (response.status === 401) {
            Cookies.remove('session-id');
            navigate('/login');
        }

        if (response.ok) {
            // Remove the domain from the current domains object
            setDomains(prevDomains => {
                const { [hostname]: removed, ...remainingDomains } = prevDomains; // Destructure to remove the hostname
                return remainingDomains;
            });
        }
    }

    const handlePoolAction = async (hostname, pool, state) => {
        console.log(`${state ? 'add': 'remove'} ${hostname} ${state ? 'to' : 'from'} ${pool}`);
        console.log({ pool: pool, hostname: hostname, state: true });

        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/pool/domain`, {
            method: "PUT",
            credentials: "include",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                pool: pool, 
                hostname: hostname, 
                state: state
            }),
        });
        if (response.status === 401) {
            Cookies.remove('session-id');
            navigate('/login');
        }

        if (response.ok) {
            if (state) {
                // Add pool to domain if state is true
                setDomains(prevDomains => {
                    const updatedDomains = { ...prevDomains };
                    updatedDomains[hostname].pools.push(pool);
                    return updatedDomains;
                });
            } else {
                // Remove pool from domain if state is false
                setDomains(prevDomains => {
                    const updatedDomains = { ...prevDomains };
                    updatedDomains[hostname].pools = updatedDomains[hostname].pools.filter(p => p !== pool);
                    return updatedDomains;
                });
            }
        }
    }
    const filteredDomains = Object.keys(domains).filter(hostname => {
        const domain = domains[hostname];
        // Check if the hostname or any pool contains the search query
        return hostname.toLowerCase().includes(searchQuery.toLowerCase()) ||
            domain.pools.some(pool => pool.toLowerCase().includes(searchQuery.toLowerCase()));
    }).reduce((obj, key) => {
        obj[key] = domains[key];
        return obj;
    }, {});

    const domainEntries = Object.entries(filteredDomains);
    const totalPages = Math.ceil(domainEntries.length / domainsPerPage);
    const startIndex = (currentPage - 1) * domainsPerPage;
    const currentDomains = domainEntries.slice(startIndex, startIndex + domainsPerPage);

    return (
        <div className='p-4 max-w-5xl mx-auto'>
            <div className="w-full flex flex-row gap-4 mt-10 p-2 items-center">
                {/* Add your search bar, filters, etc. here */}
                <div className="max-w-md my-5 mx-auto">
                    <MultiValueInput onSubmit={handleAddDomains} />
                </div>
            </div>

           
            {/* Check if there are any domains to display */}
            {currentDomains.length === 0 ? (
                <div className="my-10 text-xl font-semibold text-gray-500 text-center min-h-40 text-gray-500">No domains found.</div>
            ) : (
                <div>
                    <div className="w-1/3 max-w-xl my-5">
                        <SearchBar placeholder="Search by hostname.." onSearch={setSearchQuery} />
                    </div>
                    <div className="flex flex-wrap justify-center gap-4">
                        {currentDomains.map(([hostname, details]) => (
                            <DomainCard key={hostname} hostname={hostname} details={details} onDelete={handleDeleteDomain} pools={pools} handlePoolAction={handlePoolAction} />
                        ))}
                    </div>
                </div>
            )}

            {/* Pagination Component */}
            {totalPages > 1 && (
                <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange}  />
            )}
        </div>
    );
}

export default DomainsPage;